/**
 * A cancelled request is not a fault.
 *
 * The browser aborts work all the time: the map lets go of tiles the moment its
 * page closes, a photo is replaced before it finishes downloading, a visitor
 * navigates while the guide is still filling in. Each of those surfaces as an
 * AbortError, and an unmounted library cannot always catch its own. Reporting
 * them fills the error log with events that describe normal browsing.
 *
 * Only genuine cancellations are dropped. Every other failure — a network drop,
 * a 500, a bug in the app — travels exactly as it did before.
 */
const cancellation = (value) => {
  if (!value) return false;
  const name = value.name || value.error?.name;
  if (name === "AbortError") return true;
  const message = String(value.message || "");
  return /the operation was aborted|signal is aborted/i.test(message) && !/aborted by the server/i.test(message);
};

export function ignoreCancelledRequests() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (cancellation(event.reason)) event.preventDefault();
    },
    true
  );

  window.addEventListener(
    "error",
    (event) => {
      if (!cancellation(event.error)) return;
      event.preventDefault();
      event.stopImmediatePropagation?.();
    },
    true
  );
}